import { render, staticRenderFns } from "./Recapulation.vue?vue&type=template&id=ecd63010&scoped=true"
import script from "./Recapulation.vue?vue&type=script&lang=js"
export * from "./Recapulation.vue?vue&type=script&lang=js"
import style0 from "./Recapulation.vue?vue&type=style&index=0&id=ecd63010&prod&lang=css"
import style1 from "./Recapulation.vue?vue&type=style&index=1&id=ecd63010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd63010",
  null
  
)

export default component.exports